import { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { SingleCreatedDateFilter } from '~/components/Filters/DateFilter/SingleCreatedDateFilter';
import { FilterTrigger } from '~/components/Filters/SingleFilters/FilterTrigger';
import { type SingleFilterProps } from '~/components/Filters/types';
import { baseFiltersOptions } from '~/components/FiltersMenu/types';
import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { removeFilterAction } from '~/store/filters/actions';
import { type SelectedFilter } from '~/store/filters/types';

export type CreatedDateFilterTriggerProps = SingleFilterProps;

export const CreatedDateFilterTrigger = memo(
  ({ onApplyClick, onRemoveClick, onOpenChange }: CreatedDateFilterTriggerProps) => {
    const dispatch = useDispatch();
    const { createdDateParam } = useFilterParams();

    const content = useMemo(() => <SingleCreatedDateFilter onApplyClick={onApplyClick} />, [onApplyClick]);

    const removeFilter = useCallback(async () => {
      const filter: SelectedFilter = { type: 'dateCreated' };
      dispatch(removeFilterAction({ filter }));
      onRemoveClick?.([filter]);
    }, [dispatch, onRemoveClick]);

    return (
      <FilterTrigger
        onRemoveClick={removeFilter}
        count={createdDateParam?.start || createdDateParam?.end ? 1 : 0}
        filterContent={content}
        title={baseFiltersOptions['dateCreated'].label}
        Icon={baseFiltersOptions['dateCreated'].icon}
        onOpenChange={onOpenChange}
      />
    );
  },
);

CreatedDateFilterTrigger.displayName = 'CreatedDateFilterTrigger';
